export default __webpack_public_path__ + "static/media/tab.ee67f3f7.svg";